import React from "react";

import { Row, Card, Avatar } from "antd";

const StudentProfileCard = ({student={}}) => {
  const getBoarGradeString = ()=>{
    if (!student) return ""
    const {board,level,section="A"} = student
    return `${level} (${section} ${board})`
  }
  return (
    <Row >
      <Card style={{width:"100%"}} >
        <div className="gx-user-wid-row">
          <div className="gx-user-wid gx-mr-3">
           <Avatar src={student.avatar || "https://via.placeholder.com/150"}  size={64}/>
          </div>
          <div className="gx-user-wid-body" style={{display:"flex", flexDirection:"row"}}>
            <div className="ant-row-flex"  style={{display:"flex", flexDirection:"column",borderRight:"2px inset #d9d9d9",paddingRight:"20px"}}>
              <h2 className="h4 gx-mr-1 gx-mb-1">{student.name || "Mila Alba"}</h2>
              <h3 className="h4 gx-mr-1 gx-mb-1">{getBoarGradeString()}</h3>
              <h3 className="h4 gx-mr-1 gx-mb-1">Plan: {student.isSubscribed?"Pro":"Starter"}</h3>
            </div>
            <div className="ant-row-flex" style={{display:"flex", flexDirection:"column", borderRight:"2px inset #d9d9d9", paddingLeft:"20px", }}>
              <h2 className="h4 gx-mr-1 gx-mb-1">Points : {student.total_points}</h2>
              <h2 className="h4 gx-mr-1 gx-mb-1">Rank : {student.monthly_rank}</h2>
            </div>
            <div className="ant-row-flex" style={{display:"flex", flexDirection:"column", paddingLeft:"20px", }}>
              <h2 className="h4 gx-mr-1 gx-mb-1">Mental Maths Level : {student.skill_level}/32</h2>
            </div>
            {/* <p className="gx-mb-1 gx-text-grey gx-fs-sm">Creative Head<br /> @example</p> */}
            
          </div>
        </div>
      </Card>
    </Row>
  );
}

export default StudentProfileCard;
